/**
 * Represents a reference object.
 */
export class Reference {
  /**
   * The name of the reference.
   */
  referenceName: ReferenceName;

  /**
   * An array of reference values.
   */
  referenceValueArray: string[];

  /**
   * Constructs a new Reference instance.
   * @param {Partial<Reference>} options - An object containing optional properties for the reference.
   */
  constructor(options: Partial<Reference>) {
    this.referenceName = options.referenceName as ReferenceName;
    this.referenceValueArray = options.referenceValueArray || [];
  }
}

/**
 * Enumerates the possible reference names.
 */
export const enum ReferenceName {
  answer2Text = 'answer2Text',
  answerBackground = 'answerBackground',
  flag = 'flag',
  pronunciation = 'pronunciation',
  questionBox = 'questionBox',
  reference = 'reference',
  touchPoint = 'touchPoint'
}
